import BlendedSectorWeightings from "@/components/benchmark/BlendedSectorWeightings";

const PORTFOLIOS = [1, 2, 3, 4, 5] as const;

export default function RSectorWeightings() {
  return (
    <BlendedSectorWeightings
      side="r"
      portfolios={PORTFOLIOS}
      title="R Sector Weightings"
      portfolioLabel={(p) => `R${p}`}
      policyRange="R"
    />
  );
}
